export default "__VITE_ASSET__eba495fc__"